import WarningIcon from "../../src/assets/images/toastWarningIcon.png";
import giftIcon from "../../src/assets/images/notifications/icon-gift.svg";
import smileIcon from "../../src/assets/success.png"
import holidaygiftIcon from "../../src/assets/holidayreferalimage.svg";
import smileyIcon from "../../src/assets/images/notifications/icon-smiley.svg"
import infoIcon from "../../src/assets/images/notifications/icon-circle-exclamation.svg"
import informationIcon from "../../src/assets/images/notifications/icon-circle-info.svg"
import StarIcon from "../../src/assets/images/notifications/star.svg"

export const bannerDisplayPages = {
  "CCBanner": ["home", "view-payments", "payment-methods"],
  "RoadBoreBanner": ["home", "appointments"],
  "BDBanner": ["home", "appointments"],
  "Initial-login-CTL-User": ["account-info"],
  "User-Suspended-Vacation": ["home", "plan-details", "account-info"],
  "disableChangePlanFeatureNotification": ["plan-details"],
  "changePlanPreInstallation": ["plan-details"],
  "changePlanPending": ["plan-details"],
  "User-Has-No-ACP": ["home"],
  "User-Suspended": ["home","plan-details"],
  "ReferalBanner": ["home"],
  "holidayReferal":["home"],
  "Initial-login-CTL-Welcome": ["home"],
  "Download-Banner": ["home", "view-payments", "payment-methods", "appointments", "account-info", "plan-details", "network-info", "help-and-support"],
  "JeopardyBanner":["home"],
  "AutoPayRemoval":["payment-methods"],
  "ctlpaypaluser": ["payment-methods"],
  "qbpBanner":["agent-quick-bill-pay"],
  "DSL-Migrator": ["home", "view-payments", "payment-methods", "appointments", "account-info", "plan-details", "network-info", "help-and-support"],
  "DSL-Migrator-Eligible": ["home", "view-payments", "payment-methods", "appointments", "account-info", "plan-details", "network-info", "help-and-support"],
  "IWP-InEligible": ["home", "view-payments", "payment-methods", "appointments", "account-info", "plan-details", "network-info", "help-and-support"],
  "POTS-Migrator-InEligible" :  ["home", "view-payments", "payment-methods", "appointments", "account-info", "plan-details", "network-info", "help-and-support"],
  "DSL-POTS-Migrator-Eligible" :["home", "view-payments", "payment-methods", "appointments", "account-info", "plan-details", "network-info", "help-and-support"], 
  "POTS-Migrator-Eligible": ["home", "view-payments", "payment-methods", "appointments", "account-info", "plan-details", "network-info", "help-and-support"],
  "InstallationExtendBanner":["home"],
  "BUser-Suspended":["home"],
  "NEW_EQUIP_INSTALL": ["home","plan-details"],
  "FIBER_MIGRATION_PENDING": ["home","plan-details"],
  "FIBER_MIGRATION_SUCCESS": ["home"],
  // "NEW_LOGIN": [undefined,"login", "set-password", "signUp"]
};
export const pageBanners = {
  "home": [
    "User-Suspended",
    "ReferalBanner",
    "holidayReferal",
    "User-Has-No-ACP",
    "CCBanner",
    "RoadBoreBanner",
    "Initial-login-CTL-Welcome",
    "User-Suspended-Vacation",
    "Download-Banner",
    "BDBanner",
    "JeopardyBanner",
    "DSL-Migrator",
    "DSL-Migrator-Eligible",
    "IWP-InEligible",
    "POTS-Migrator-InEligible", 
    "DSL-POTS-Migrator-Eligible",
    "POTS-Migrator-Eligible",
    "InstallationExtendBanner",
    "BUser-Suspended",
    "NEW_EQUIP_INSTALL",
    "FIBER_MIGRATION_PENDING",
    "FIBER_MIGRATION_SUCCESS"
  ],
  "account-info": ["Initial-login-CTL-User", "User-Suspended-Vacation", "Download-Banner", "DSL-Migrator","DSL-Migrator-Eligible","IWP-InEligible","POTS-Migrator-InEligible", "DSL-POTS-Migrator-Eligible","POTS-Migrator-Eligible"],
  "plan-details": [
    "changePlanPreInstallation",
    "changePlanPending",
    "User-Suspended-Vacation",
    "disableChangePlanFeatureNotification",
    "Download-Banner",
    "User-Suspended",
    "DSL-Migrator",
    "DSL-Migrator-Eligible",
    "IWP-InEligible",
    "POTS-Migrator-InEligible", 
    "DSL-POTS-Migrator-Eligible",
    "POTS-Migrator-Eligible",
    "FIBER_MIGRATION_PENDING",
    "NEW_EQUIP_INSTALL"
  ],
  "appointments": ["BDBanner", "RoadBoreBanner", "Download-Banner", "DSL-Migrator",  "DSL-Migrator-Eligible", "IWP-InEligible", "POTS-Migrator-InEligible", "DSL-POTS-Migrator-Eligible","POTS-Migrator-Eligible"],
  "view-payments": ["CCBanner", "Download-Banner", "DSL-Migrator","DSL-Migrator-Eligible","IWP-InEligible","POTS-Migrator-InEligible", "DSL-POTS-Migrator-Eligible","POTS-Migrator-Eligible"],
  "payment-methods": ["CCBanner","AutoPayRemoval","ctlpaypaluser", "Download-Banner", "DSL-Migrator","DSL-Migrator-Eligible","IWP-InEligible","POTS-Migrator-InEligible", "DSL-POTS-Migrator-Eligible","POTS-Migrator-Eligible"],
  "agent-payment-arrangements":["PaymentArrangements"],
  "network-info": ["Download-Banner", "DSL-Migrator","DSL-Migrator-Eligible","POTS-Migrator-InEligible", "DSL-POTS-Migrator-Eligible","POTS-Migrator-Eligible"],
  "help-and-support": ["Download-Banner" , "DSL-Migrator","DSL-Migrator-Eligible","POTS-Migrator-InEligible", "DSL-POTS-Migrator-Eligible","POTS-Migrator-Eligible"],
  "agent-quick-bill-pay": ["qbpBanner"],
};

export const bannersEmoji = {
  starBanners: ["BRSPD_VAS", "FQF_VAS"],
  giftBanners: ["DSL-POTS-Migrator-Eligible", "DSL-Migrator-Eligible",  "IWP-InEligible", "POTS-Migrator-Eligible", "POTS-Migrator-InEligible"],
  successBanners: [
    "PaymentArrangements",
    "Initial-login-CTL-Welcome",
    "qbpBanner",
    "outageRestoreBanner",
  ],
  warningBanners: [],
  appointments: [],
  infoBanners: [
    "ctlpaypaluser",
    "CCBanner",
    "BDBanner",
    "ModemRestarted",
    "AutoPayRemoval",
    "User-Has-No-ACP",
    "User-Suspended-Vacation",
    "User-Suspended",
    "JeopardyBanner",
    "BUser-Suspended",
    "CtlPayPalUser",
    "ReferalBanner",
    "Initial-login-CTL-User",
    "InstallationExtendBanner",
    "RoadBoreBanner",
    "DSL-Migrator",
    "FIBER_MIGRATION_PENDING",
    "NEW_EQUIP_INSTALL",
  ],
  infoCircle : [
  "changePlanPreInstallation",
  "changePlanPending",
  "Installation-pending",
  ],
  holidayBanners: [
    "holidayReferal"
  ],
  appDownload : [
    "Download-Banner",
    "FIBER_MIGRATION_SUCCESS"
  ],
  empty:[
    "NEW_LOGIN"
  ]
};

export const getBannerCategory=(key)=>{
  switch (true) {
    case bannersEmoji.starBanners?.includes(key):
      return 'star';
    case bannersEmoji.giftBanners?.includes(key):
      return 'gift';
    case bannersEmoji.successBanners?.includes(key):
      return 'success';
    case bannersEmoji.warningBanners?.includes(key):
      return 'warning';
    case bannersEmoji.infoBanners?.includes(key):
      return 'info';
      case bannersEmoji.holidayBanners?.includes(key):
        return 'holidayReferal';
    case bannersEmoji.appDownload?.includes(key):
      return 'appDownload';  
    case bannersEmoji.infoCircle?.includes(key):
        return 'infoCircle';
    case bannersEmoji.empty?.includes(key): 
        return 'empty';   
    default:
      return 'info'; // In case the key doesn't match any category
  }
}

export const getImageSrc=(key)=> {
  const category = getBannerCategory(key);
  switch (category) {
    case 'star' :
      return StarIcon;
    case 'gift':
      return giftIcon;
    case 'success':
      return smileyIcon;
    case 'warning':
      return WarningIcon;
    case 'info':
      return infoIcon;
      case 'holidayReferal':
        return holidaygiftIcon;
    case 'appDownload':
      return smileyIcon;
    case 'infoCircle':
      return informationIcon;
    case 'empty':
      return null;
    default:
      return WarningIcon; // Default or fallback icon
  }
}

export const getAltText = (key) => {
  const category = getBannerCategory(key);
  switch (category) {
    case 'star' :
      return 'star Icon';
    case 'gift':
      return 'gift Icon';
    case 'success':
      return 'smiley Icon';
    case 'warning':
      return 'Warning Icon';
    case 'info':
      return 'Warning Icon';
      case 'holidayReferal':
        return "holiday Referal Icon";
    case 'appDownload':
          return "smiley Icon";    
    case 'infoCircle':
        return "info Icon";
    default:
      return 'Warning Icon';
  }
};

export const getAriaLabel = (key) => {
  const category = getBannerCategory(key);
  switch (category) {
    case 'star' :
      return 'Notification banner star';
    case 'gift':
      return 'Notification banner great rewards';
    case 'success':
      return 'Notification banner information';
    case 'warning':
      return 'Notification banner warning';
    case 'info':
      return 'Notification banner warning';
      case 'holidayReferal':
        return "Hoilday offer notification banner information'";
    case 'appDownload':
      return "notification banner information'";    
    case 'infoCircle':
        return 'Notification banner information';
    default:
      return 'Notification banner warning';
  }
};

